'use client';

import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Button, CircularProgress, Typography } from '@mui/material';
import { fetchAuthSession } from '@parkchirp/api-client';
import { useState } from 'react';
import type { SetShowSnackbar } from '../../types/alerts';

interface PayorMigrationProps {
	wordpressUserId: number;
	setShowSnackbar: SetShowSnackbar;
}

export const PayorMigration = ({ wordpressUserId, setShowSnackbar }: PayorMigrationProps) => {
	const [migratePayorLoading, setMigratePayorLoading] = useState(false);
	if (!wordpressUserId) return null;
	return (
		<>
			<Typography style={{ display: 'flex', alignItems: 'center' }}>
				<ReportProblemIcon style={{ color: '#ff0000', marginRight: '5px' }} />
				Payor Migration Required
			</Typography>
			<Button
				disabled={migratePayorLoading}
				onClick={async () => {
					setMigratePayorLoading(true);
					const { idToken } = (await fetchAuthSession()).tokens ?? {};

					const response = await fetch(`${process.env.NEXT_PUBLIC_MONTHLY_USER_MICRO_URL}/migrate-payor`, {
						method: 'POST',
						body: JSON.stringify({ wordpressUserId }),
						headers: {
							Authorization: `Bearer ${idToken}`,
						},
					});

					if (!response.ok) {
						setShowSnackbar({
							message: 'Failed to migrate payor',
							severity: 'error',
							autoHideDuration: 3000,
							onClose: () => {
								setShowSnackbar(null);
							},
						});
						setMigratePayorLoading(false);
						return;
					}
					const jsonResponse = await response.json();
					if (jsonResponse.errorMessage) {
						setShowSnackbar({
							message: jsonResponse.errorMessage,
							severity: 'error',
							autoHideDuration: 3000,
							onClose: () => {
								setShowSnackbar(null);
							},
						});
						setMigratePayorLoading(false);
					} else {
						window.location.reload();
					}
				}}
			>
				Migrate Payor {migratePayorLoading ? <CircularProgress /> : null}
			</Button>
		</>
	);
};
